import anime from 'animejs';

export function bigtitleInit(el) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const letters = [...ctx.querySelectorAll('.name__letter')];

  anime.set(letters, { translateY: '-100%' });
}

export function bigtitleAnim(el, delay = 0) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const letters = [...ctx.querySelectorAll('.name__letter')];
  const tween = anime({
    targets: letters,
    translateY: '0%',
    duration: 1500,
    easing: 'easeOutCirc',
    delay: anime.stagger(150, {
      start: delay,
      from: 'center',
    }),
  });

  return tween;
}
